<div class="agpr-journodexQuickSearch" role="search">
    <span id="searchLabel" class="u-srOnly">{{ 'Common.journodexQuickSearch.searchLabel' | localize }}</span>
    <agpr-grouped-autocomplete
        [(ngModel)]="search"
        [suggestionsFetcher]="performAutocomplete.bind(this)"
        [placeholder]="'Common.journodexQuickSearch.placeHolder' | localize"
        [labelField]="'entityName'"
        [groupTemplate]="groupTemplate"
        [itemsListTemplate]="itemsListTemplate"
        (itemSelected)="navigateToSelectedProfile($event)"
        (viewAllInGroup)="viewAllInGroup($event)"
        (researchRequest)="openResearchRequestDialog($event)"
        ariaLabelledBy="searchLabel"
        inputType="text"
        autocomplete="off"
    >
    </agpr-grouped-autocomplete>
</div>

<ng-template  let-triggerViewAllInGroup="triggerViewAllInGroup" let-group pTemplate="group" #groupTemplate>
    <div class="agpr-journodexQuickSearch-group">
        {{ group.label | localize }}
        <agpr-button
            label="viewAll"
            [ariaLabel]="('viewAll' | localize) + ' ' + (group.label | localize)"
            [style]="buttonTypesEnum.tertiary"
            (click)="triggerViewAllInGroup(group)"
            class="agpr-journodexQuickSearch-viewAll"
        ></agpr-button>
    </div>
</ng-template>

<!-- eslint-disable @angular-eslint/template/interactive-supports-focus, @angular-eslint/template/role-has-required-aria -->
<ng-template #itemsListTemplate let-suggestionsToDisplay let-selectItem="selectItem" let-group="group" let-triggerResearchRequest="triggerResearchRequest">
    <ng-container
        *ngFor="let option of suggestionsToDisplay; let idx = index; first as isFirst; last as isLast"
    >
        <li
            role="option"
            class="p-autocomplete-item agpr-journodexQuickSearch-listItemContainer"
            pRipple
            [ngClass]="{
                'agpr-journodexQuickSearch-listItemContainer--first': isFirst,
                'agpr-journodexQuickSearch-listItemContainer--last': isLast
            }"
            (click)="selectItem(option)"
        >
            <ng-container *ngTemplateOutlet="itemTemplate; context: {$implicit: option, index: idx}"></ng-container>
        </li>
    </ng-container>

    <li
        *ngIf="!suggestionsToDisplay || !suggestionsToDisplay.length"
        class="p-autocomplete-empty-message group"
        role="option"
    >
        <div
            *ngIf="group.value === 'CONTACT'"
            class="agpr-journodexQuickSearch-noListItems"
        >
            <span class="agpr-journodexQuickSearch-noListItemsIcon fa-regular fa-duotone fa-user" aria-hidden="true"></span>
            <div
                class="agpr-journodexQuickSearch-noListItems-message"
            >
                <div class="agpr-journodexQuickSearch-noListItems-messageHeading">
                    {{ 'Common.journodexQuickSearch.noMatchingContacts' | localize}}
                </div>
                <div class="agpr-journodexQuickSearch-noListItems-messageOptions">
                    <div class="agpr-journodexQuickSearch-noListItems-messageOption">
                        <a href="Discover/privatecontacts/editor">
                            {{ 'Common.journodexQuickSearch.createPrivateContact' | localize }}
                        </a>
                        <span
                            role="img"
                            class="agpr-journodexQuickSearch-noListItems-messageOption-infoIcon fa-regular fa-circle-info"
                            agprTooltip="Common.journodexQuickSearch.createPrivateContact.info"
                        ></span>
                    </div>
                    <div class="agpr-journodexQuickSearch-noListItems-messageOption">
                        <a href="javascript:;" (click)="triggerResearchRequest()">{{ 'Common.journodexQuickSearch.sendResearchRequest' | localize }}</a>
                        <span
                            role="img"
                            class="agpr-journodexQuickSearch-noListItems-messageOption-infoIcon fa-regular fa-circle-info"
                            agprTooltip="Common.journodexQuickSearch.sendResearchRequest.info"
                        ></span>
                    </div>
                </div>
            </div>
        </div>
        <div
            *ngIf="group.value === 'OUTLET'"
            class="agpr-journodexQuickSearch-noListItems"
        >
            <span class="agpr-journodexQuickSearch-noListItemsIcon fa-kit-duotone fa-agpr-outlet" aria-hidden="true"></span>
            <div
                class="agpr-journodexQuickSearch-noListItems-message"
            >
                <div class="agpr-journodexQuickSearch-noListItems-messageHeading">
                    {{ 'Common.journodexQuickSearch.noMatchingOutlets' | localize}}
                </div>
                <div class="agpr-journodexQuickSearch-noListItems-messageOptions">
                    <div class="agpr-journodexQuickSearch-noListItems-messageOption">
                        <a href="javascript:;" (click)="triggerResearchRequest()">{{ 'Common.journodexQuickSearch.sendResearchRequest' | localize }}</a>
                        <span
                            role="img"
                            class="agpr-journodexQuickSearch-noListItems-messageOption-infoIcon fa-regular fa-circle-info"
                            agprTooltip="Common.journodexQuickSearch.sendResearchRequest.info"
                        ></span>
                    </div>
                </div>
            </div>
        </div>
    </li>
</ng-template>
<!-- eslint-enable @angular-eslint/template/interactive-supports-focus, @angular-eslint/template/role-has-required-aria -->
<ng-template let-item #itemTemplate>
    <agpr-journodex-entity-list-item
        [entity]="item"
    ></agpr-journodex-entity-list-item>
</ng-template>
